module.exports = __webpack_public_path__ + "media/homepage.5a2d51ce.mp4";